import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { EditableMenuHelpsDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RefreshMenuService } from 'src/app/core/services/refresh-menu.service';
import { MenusService } from '../../../core/api/services';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { MenuListItemDto } from './../../../core/api/models/menu-list-item-dto';
import { PaginatedListOfMenuListItemDto } from './../../../core/api/models/paginated-list-of-menu-list-item-dto';
import { UpdateMenuCommand } from './../../../core/api/models/update-menu-command';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { MenuHelpsFormComponent } from './menu-helps-form/menu-helps-form.component';
import { MenusFormComponent } from './menus-form/menus-form.component';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  imports: [BaseIndexModule, MenusFormComponent, MenuHelpsFormComponent],
})
export class MenusComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties
  pageName = PageNames.menus;

  /* Binding service endpoints */
  protected currentService = inject(MenusService);
  paginationApiMethodName: string =
    this.currentService.menusGetMenusWithPagination.name;
  createGetApiMethodName: string = this.currentService.menusCreateGet.name;
  auditApiMethodName: string = this.currentService.menusGetMenusAudit.name;
  deleteApiMethodName: string = this.currentService.menusDelete.name;

  modelWithPagination$: Observable<PaginatedListOfMenuListItemDto>;
  items$: Observable<Array<MenuListItemDto>>;
  formPageConfig: FormPageConfig<UpdateMenuCommand> = {};
  isVisibleHelpForm;
  isShowMenuHelps: boolean = false;
  menuHelpsData: EditableMenuHelpsDto;
  menuId: number;
  //#endregion

  constructor(public refreshMenuService: RefreshMenuService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showHeader = false;
      this.pageConfig.tableConfig.hidePagination = true;
      this.pageConfig.tableConfig.hidePageSize = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: this.localizer.parent,
        name: 'parent.title',
        hasSearch: true,
      },
      { title: `${this.tableVocabs}route`, name: 'route', hasSearch: true },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region api methods

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .menusUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  onRefreshMenus() {
    this.pageConfig.loading = true;

    this.currentService
      .menusGetAsideMenus()
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.pageConfig.loading = false;
        })
      )
      .subscribe((items) => {
        this.refreshMenuService.setNewMenu(items?.data);
      });
  }

  onMenuHelps(menuId) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.currentService
      .menusUpdateMenuHelpsGet({ Id: menuId })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.pageConfig.loading = false;
        })
      )
      .subscribe((data) => {
        if (data.isSucceed) {
          this.menuHelpsData = data.data;
          this.menuId = menuId;
          this.isShowMenuHelps = true;
        }
      });
  }
  //#endregion
}
